/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Automation_Trigger_Task_ReopenedInputs */

const en_automation_trigger_task_reopened = /** @type {(inputs: Automation_Trigger_Task_ReopenedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} reopened`)
};

const pt_br2_automation_trigger_task_reopened = /** @type {(inputs: Automation_Trigger_Task_ReopenedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} reaberta`)
};

/**
* | output |
* | --- |
* | "{task} reopened" |
*
* @param {Automation_Trigger_Task_ReopenedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_trigger_task_reopened = /** @type {((inputs: Automation_Trigger_Task_ReopenedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trigger_Task_ReopenedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trigger_task_reopened(inputs)
	return pt_br2_automation_trigger_task_reopened(inputs)
});